// BIGBANG 專輯類型定義與工具函數
// 這個檔案可以在 client 和 server 端使用

export interface Track {
  number: number;
  title: string;
  titleKo?: string | null;
  duration?: string | null;
  isTitle?: boolean | null;
}

export interface Album {
  id: number;
  slug: string;
  title: string;
  titleKo?: string | null;
  artist: string;
  artistType: string;
  member?: string | null;
  year: number;
  releaseDate: string;
  albumType: string;
  coverUrl: string;
  tracks: Track[];
}

// 成員代表色
export function getMemberColor(member?: string | null): string {
  if (!member) return '#D4AF37';
  const colors: Record<string, string> = {
    GD: '#ED609F',
    Taeyang: '#D7171E',
    TOP: '#8FC126',
    Daesung: '#F4E727',
    Seungri: '#1E92C6',
  };
  return colors[member] || '#D4AF37';
}
